import { createURLProxy } from '../utils/shape-utils';

export default createURLProxy({
  fetchUser: '/user',
  fetchTranslations: '/translations/{languageCode}',
});
